module.exports = __webpack_public_path__ + "static/media/pins2.a65c2972.jpg";